<template>
  <div class="login-page">
    <!-- 语言切换（右上角） -->
    <div class="lang">
      <span :class="{ on: curLang === 'km' }" @click="setLang('km')">ខ្មែរ</span>
      <span class="sep">|</span>
      <span :class="{ on: curLang === 'en' }" @click="setLang('en')">EN</span>
      <span class="sep">|</span>
      <span :class="{ on: curLang === 'zh' }" @click="setLang('zh')">中文</span>
    </div>

    <!-- 左右装饰图：固定在左右下角 -->
    <img class="phone" :src="imgPhone" alt="phone" />
    <img class="moto" :src="imgMoto" alt="moto" />

    <!-- 中间竖条 -->
    <div class="panel">
      <img class="logo" :src="imgLogo" alt="logo" />
      <div class="panel-title">{{ $t("login.registerTitle") }}</div>

      <div class="form">
        <div class="label">{{ labelUsername }}</div>
        <div class="input-row">
          <div class="icon-circle"><i class="el-icon-user"></i></div>
          <input
              class="input"
              v-model.trim="username"
              autocomplete="username"
              @blur="checkUsername"
          />
        </div>
        <div v-if="usernameHint" class="hint" :class="{ bad: !usernameOk }">
          {{ usernameHint }}
        </div>

        <div class="label mt12">{{ labelPassword }}</div>
        <div class="input-row">
          <div class="icon-circle"><i class="el-icon-lock"></i></div>
          <input
              class="input"
              v-model="password"
              type="password"
              autocomplete="new-password"
          />
        </div>

        <div class="label mt12">{{ labelConfirmPassword }}</div>
        <div class="input-row">
          <div class="icon-circle"><i class="el-icon-lock"></i></div>
          <input
              class="input"
              v-model="confirmPassword"
              type="password"
              autocomplete="new-password"
          />
        </div>

        <!-- 货币（你后端默认 KHR，这里先锁死也行） -->
        <div class="label mt12">{{ $t("login.currency") }}</div>
        <div class="input-row">
          <div class="icon-circle"><i class="el-icon-coin"></i></div>
          <select class="input" v-model="currency">
            <option value="KHR">KHR</option>
          </select>
        </div>

        <!-- 按钮区域 -->
        <div class="button-group">
          <button class="btn login-btn" :disabled="loading" @click="onSubmit">
            {{ loading ? "..." : $t("login.submitRegister") }}
          </button>

          <div class="register-section">
            <button class="btn register-btn" :disabled="loading" @click="goLogin">
              {{ $t("login.backToLogin") }}
            </button>
          </div>
        </div>

        <div v-if="error" class="error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkUsernameApi } from "@/api/auth";

export default {
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: "",
      currency: "KHR",
      loading: false,
      error: "",
      usernameOk: false,
      usernameHint: ""
    };
  },
  computed: {
    curLang() {
      return this.$i18n.locale;
    },
    // 图片（沿用登录页同一套）
    imgLogo() { return require("@/assets/img/login-logo.png"); },
    imgPhone() { return require("@/assets/img/phone.png"); },
    imgMoto() { return require("@/assets/img/moto.png"); },

    // 高棉模式显示 “高棉 | English”
    labelUsername() {
      if (this.curLang === "km") return "ឈ្មោះគណនី | Username";
      return this.$t("login.username");
    },
    labelPassword() {
      if (this.curLang === "km") return "លេខសម្ងាត់ | Password";
      return this.$t("login.password");
    },
    labelConfirmPassword() {
      if (this.curLang === "km") return "បញ្ជាក់លេខសម្ងាត់ | Confirm Password";
      return this.$t("login.confirmPassword");
    }
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
    },

    goLogin() {
      this.$router.replace("/login");
    },

    async checkUsername() {
      this.usernameHint = "";
      this.usernameOk = false;

      const u = (this.username || "").trim();
      if (!u) return;

      try {
        const res = await checkUsernameApi(u);
        const data = res.data || res;

        this.usernameOk = !!data.available;
        this.usernameHint = data.message || (data.available ? "OK" : "Not available");
      } catch (e) {
        this.usernameHint = (e && e._friendlyMessage) || e.message || this.$t("login.checkFailed");
      }
    },

    async onSubmit() {
      this.error = "";

      const u = (this.username || "").trim();
      if (!u || !this.password || !this.confirmPassword) {
        this.error = this.$t("login.needInputRegister");
        return;
      }
      if (this.password !== this.confirmPassword) {
        this.error = this.$t("login.passwordNotMatch");
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch("auth/register", {
          username: u,
          password: this.password,
          confirmPassword: this.confirmPassword,
          currency: this.currency,
          // 需要也可以传 remember：默认不传就是 localStorage（你 store 里规则）
          // remember: true
        });
        this.$router.replace("/lotto");
      } catch (e) {
        this.error = (e && e._friendlyMessage) || e.message || this.$t("login.registerFailed");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
/* ====== 完整复用 Login.vue 样式（保持一致） ====== */

/* 页面底色 + 底图水印（关键：不使用 cover，避免被放大） */
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: #edf6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-page::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("~@/assets/img/login.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 1600px auto;
  opacity: 0.9;
  pointer-events: none;
}

/* 右上角语言 */
.lang {
  position: absolute;
  top: 14px;
  right: 18px;
  z-index: 5;
  font-size: 12px;
  color: #1f5f8a;
  user-select: none;
}

.lang span {
  cursor: pointer;
}

.lang .sep {
  margin: 0 6px;
  opacity: .4;
  cursor: default;
}

.lang .on {
  font-weight: 800;
  text-decoration: underline;
}

/* 左右底部图片 */
.phone, .moto {
  position: absolute;
  bottom: 40px;
  z-index: 2;
  pointer-events: none;
  user-select: none;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.10));
}

.phone {
  left: 90px;
  width: 360px;
}

.moto {
  right: 90px;
  width: 420px;
}

/* 中间蓝色竖条 */
.panel {
  position: relative;
  z-index: 3;
  width: 420px;
  padding: 24px 34px 28px;
  box-sizing: border-box;
  background: rgba(126, 164, 188, 0.75);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* logo + 标题 */
.logo {
  width: 110px;
  margin-top: 6px;
}

.panel-title {
  margin-top: 10px;
  font-weight: 900;
  letter-spacing: 1px;
  color: #d4b06b;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
}

/* 表单 */
.form {
  width: 100%;
  margin-top: 18px;
}

.label {
  font-size: 12px;
  color: #1f5f8a;
  font-weight: 700;
}

.mt12 {
  margin-top: 12px;
}

/* 输入胶囊 */
.input-row {
  margin-top: 6px;
  height: 42px;
  border-radius: 999px;
  background: rgba(240, 248, 255, 0.9);
  display: flex;
  align-items: center;
  padding: 0 12px 0 8px;
  border: 1px solid rgba(20, 90, 140, 0.12);
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #0f5f8f;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.input {
  border: 0;
  outline: none;
  background: transparent;
  width: 100%;
  height: 38px;
  font-size: 14px;
  color: #0e3e5e;
}

/* hint */
.hint {
  margin-top: 6px;
  font-size: 12px;
  color: #1b8f4d;
  text-align: center;
}
.hint.bad {
  color: #c0392b;
}

/* 按钮（参考图：小圆角、居中） */
.btn {
  margin-top: 14px;
  width: 120px;
  height: 36px;
  border-radius: 999px;
  border: 0;
  cursor: pointer;
  background: #0f5f8f;
  color: #fff;
  font-weight: 800;
  letter-spacing: 1px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  color: #c0392b;
}

/* 小屏隐藏左右图 */
@media (max-width: 1100px) {
  .phone, .moto {
    display: none;
  }

  .login-page::before {
    background-size: 1100px auto;
  }
}
</style>
